import React from 'react';


import { Modal, Spin, Table } from 'antd';
import Title from 'antd/es/typography/Title';
import { formatPoint } from 'app/shared/util/percent';
import * as _ from 'lodash';

type IOtherCommentEvaluationProps = {
    isOpen: boolean;
    onClose: () => void;
    data: any;
    nameCriteria: string;
    isLoading: boolean;
};

export const OtherCommentEvaluationComponent = ({ isOpen, onClose, data, nameCriteria, isLoading }: IOtherCommentEvaluationProps) => {
    const columns = [
        {
            title: <span className='fw-bold'>Người ý kiến</span>,
            key: 'userName',
            width: 250,
            render: item => item?.performerName ? `${item?.evaluateLevelName} - ${item?.performerName}` : item?.evaluateLevelName
        },
        {
            title: <span className='fw-bold'>Điểm ĐG</span>,
            key: 'point',
            width: 120,
            dataIndex: 'point',
            render: item => item ? `${formatPoint(item)}%` : undefined,
        },
        {
            title: <span className='fw-bold'>Ý kiến</span>,
            key: 'explain',
            width: 250,
            dataIndex: 'explain',
        },
    ]
    return (
        <Modal open={isOpen} maskClosable={false} footer={null} onCancel={onClose} width={'50vw'} className='view'>
            <div className="d-flex gap-5">
                <Title level={3}>{nameCriteria}</Title>
            </div>
            <Table columns={columns} pagination={false} loading={isLoading} dataSource={data?.map(value => {
                return {
                    evaluateLevelName: value.versionName,
                    key: value.versionName,
                    children: _.flatMap(value?.otherLevelPoints, item =>
                        item.performerPoints?.map(feedback => ({
                            key: feedback.performerName,
                            evaluateLevelName: item.evaluateLevelName,
                            performerName: feedback.performerName,
                            point: feedback?.evaluatePoint?.point,
                            explain: feedback?.evaluatePoint?.explain
                        })))
                }
            }


            )} />
        </Modal>
    );
};

export default OtherCommentEvaluationComponent;
